import { setApiError } from '../slices/api_errors/actions'

export const handleApiError = ({ dispatch, result, path, uniqueKey }) => {
  const httpMethod = result?.config?.method
  if (!httpMethod) {
    return
  }
  const error = parseError(result)
  dispatch(
    setApiError({
      httpMethod: httpMethod,
      route: path,
      key: uniqueKey,
      error,
    }),
  )
}
export function parseError(result) {
  if (result.response) {
    return result.response && result.response.data && result.response.data.error
  } else {
    return result
  }
}
